/*
  Shared Broadcast room behavior — entrance settle, transition-intent
  read/clear, and theme-editor lifecycle. Every [data-broadcast-room]
  root is a component: initialized once, destroyed cleanly on
  shopify:section:unload, safe to re-init on shopify:section:load.

  Deliberately minimal: navigation is native (real <a> elements), and
  the only enhancement here is atmospheric — a brief entrance settle
  and (optionally) reading a same-tab "we just came from the homepage"
  intent set in sessionStorage by assets/broadcast.js, to skip a
  redundant fade when a visitor arrives by a direct/external link
  instead of by clicking a building.
*/
(function () {
  'use strict';

  var instances = new WeakMap();
  var INTENT_KEY = 'gomez-fm:broadcast-transition-intent';

  function initRoom(root) {
    if (instances.has(root)) return;

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var timers = [];
    function after(fn, delay) {
      var id = setTimeout(fn, delay);
      timers.push(id);
      return id;
    }

    // consume the intent flag either way, so it never leaks into a
    // later, unrelated page view
    var arrivedFromBroadcast = false;
    try {
      arrivedFromBroadcast = window.sessionStorage.getItem(INTENT_KEY) === root.dataset.room;
      window.sessionStorage.removeItem(INTENT_KEY);
    } catch (e) { /* sessionStorage unavailable — settle immediately below */ }

    if (reducedMotion) {
      root.classList.add('is-settled');
    } else {
      after(function () { root.classList.add('is-settled'); }, arrivedFromBroadcast ? 60 : 0);
    }

    var pulseEls = Array.prototype.slice.call(root.querySelectorAll('[data-broadcast-pulse]'));
    if (!reducedMotion) {
      pulseEls.forEach(function (el) { el.classList.add('is-pulsing'); });
    }

    instances.set(root, {
      destroy: function () {
        timers.forEach(function (id) { clearTimeout(id); });
      }
    });
  }

  function destroyRoom(root) {
    var instance = instances.get(root);
    if (instance) {
      instance.destroy();
      instances.delete(root);
    }
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-broadcast-room]');
    for (var i = 0; i < roots.length; i++) initRoom(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    var roots = event.target.querySelectorAll('[data-broadcast-room]');
    for (var i = 0; i < roots.length; i++) destroyRoom(roots[i]);
  });
})();
